import { render, staticRenderFns } from "./DefaultThree.vue?vue&type=template&id=800d4eaa&scoped=true&"
import script from "./DefaultThree.vue?vue&type=script&lang=js&"
export * from "./DefaultThree.vue?vue&type=script&lang=js&"
import style0 from "./DefaultThree.vue?vue&type=style&index=0&id=800d4eaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "800d4eaa",
  null
  
)

export default component.exports